import React from 'react';
import ReactMarkdown from 'react-markdown';
import { ExerciseStep } from '@codey2/codey-api-types/models';
import { RemarkCodeBlockPlugin } from '../../../components/exercises/CodeBlockRenderer/remarkCodeBlockPlugin';
import styles from './StepViewer.module.css';
import { RemarkYoutubePlugin } from '../../../components/exercises/YoutubePlugin';

interface StepViewerProps {
  step: ExerciseStep;
  stepNumber: number;
  platform?: string;
}

export const StepViewer: React.FC<StepViewerProps> = ({ step, stepNumber, platform }) => {
  return (
    <div className={styles.stepViewer}>
      <div className={styles.stepHeader}>
        <span className={styles.stepBadge}>Stap {stepNumber}</span>
        <h3 className={styles.stepTitle}>{step.name}</h3>
      </div>

      <div className={styles.stepContent}>
        <ReactMarkdown
          remarkPlugins={[[RemarkCodeBlockPlugin.plugin, { platform }], RemarkYoutubePlugin.plugin]}
          components={{ ...RemarkCodeBlockPlugin.components, ...RemarkYoutubePlugin.components }}
        >
          {step.content}
        </ReactMarkdown>
      </div>
    </div>
  );
};
